import React from 'react';
import { Button, ButtonGroup, Input, Table } from 'reactstrap';
import { AFAS_LIST_MODE_OPTIONS } from '../constants';
import Loader from "react-loaders";

const AfasFilterSidebar = ({
    listMode = 'auto',
    onListModeChange,
    dagtypeFilter = '',
    onDagtypeFilterChange,
    dagtypeOptions = [],
    rows = [],
    isLoading = false,
    selectedSubstitutionId,
    selectedSubstitutorAdminId,
    selectedProlongedId = null,
    onSelectPerson,
}) => {
    return (
        <aside className="afas-filter-sidebar card shadow-sm p-3">
            <div
                className="afas-filter-sidebar__mode-toggle afas-sub-tab-bar mb-2"
                role="tablist"
                aria-label="Lijst modus"
            >
                {AFAS_LIST_MODE_OPTIONS.map((option) => (
                    <Button
                        key={option.value}
                        type="button"
                        color="primary"
                        outline={listMode !== option.value}
                        className={`afas-sub-tab ${listMode === option.value ? 'active' : 'btn-outline-secondary'}`}
                        onClick={() => onListModeChange?.(option.value)}
                        role="tab"
                        aria-selected={listMode === option.value}
                    >
                        {option.label}
                    </Button>
                ))}
            </div>

            <div className="afas-filter-sidebar__field mb-2">
                <Input
                    type="select"
                    className="form-select form-select-sm"
                    style={{ width: '40%' }}
                    value={dagtypeFilter}
                    onChange={(event) => onDagtypeFilterChange?.(event.target.value)}
                    aria-label="Filter dagtype"
                >
                    <option value="">Alle dagtypes</option>
                    {dagtypeOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </Input>
            </div>

            <div className="afas-filter-sidebar__table-wrap border rounded">
                {isLoading && (
                    <div className="afas-filter-sidebar__empty text-center text-muted p-3"><Loader
                        type="ball-grid-pulse"
                        className="mt-3 d-flex mx-auto justify-content-center"
                    /></div>
                )}

                {!isLoading && rows.length === 0 && (
                    <div className="afas-filter-sidebar__empty text-center text-muted p-3">
                        Geen openstaande verzoeken
                    </div>
                )}

                {!isLoading && rows.length > 0 && (
                    <Table hover size="sm" className="mb-0 table-borderless align-middle">
                        <thead className=" border-bottom">
                            <tr>
                                <th className="small fw-semibold text-muted">School</th>
                                <th className="small fw-semibold text-muted">Verzoek</th>
                                <th className="small fw-semibold text-muted">Naam</th>
                                <th className="small fw-semibold text-muted">Dagtype</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row) => {
                                const isActive = row.prolongedId
                                    ? Number(row.prolongedId) ===
                                    Number(selectedProlongedId)
                                    : row.substitutionId === selectedSubstitutionId &&
                                    row.substitutorAdminId ===
                                    selectedSubstitutorAdminId &&
                                    !selectedProlongedId;

                                return (
                                    <tr
                                        key={row.id}
                                        className={
                                            isActive
                                                ? 'fw-semibold cursor-pointer'
                                                : 'cursor-pointer'
                                        }
                                        onClick={() => onSelectPerson?.(row)}
                                    >
                                        <td title={row.school} className=" text-truncate" style={{ maxWidth: '100px' }}>
                                            {row.school}
                                        </td>
                                        <td >{row.verzoekId}</td>
                                        <td title={row.naam} className="text-truncate" style={{ maxWidth: '90px' }}>
                                            {row.naam}
                                        </td>
                                        <td >{row.dagtype}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                )}
            </div>

            {!isLoading && rows.length > 0 && (
                <div className="afas-filter-sidebar__results text-muted small mt-2">
                    {rows.length} resultaat{rows.length === 1 ? '' : 'en'}
                </div>
            )}
        </aside>
    );
};

export default AfasFilterSidebar;
